import { Component, OnInit } from '@angular/core';
import { KuiModalRefComponent } from 'app/key-ui/modal/modal-ref.component';
import { TranslateService } from '@ngx-translate/core';
import { IKuiModalAction } from 'app/key-ui';

export interface ThemeJsonModalOptions {
    settings: any;
}


@Component({
    templateUrl: './json-modal.component.html',
})
export class ThemeJsonModalComponent extends KuiModalRefComponent<ThemeJsonModalOptions> implements OnInit {

    modalActions: IKuiModalAction[];
    json: string;
    errorMessage: string;

    constructor(private i18n: TranslateService) {
        super();
    }


    ngOnInit() {

        this.json = JSON.stringify(this.data.settings, null, 4);

        this.modalActions = [{
            text: this.i18n.instant('DIALOG.CANCEL'),
            style: 'secondary',
            action: () => this.actions.close(),
        }, {
            text: this.i18n.instant('DIALOG.SAVE'),
            style: 'primary',
            action: async () => {

                try {
                    const settings = JSON.parse(this.json);
                    await this.actions.save(settings);
                    this.closeModal();
                } catch (err) {
                    console.log(err);
                    this.errorMessage = err.message;
                    return true;
                }
            },
        }];

    }


}
